<div id="task-elimination-modal">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Notificación de eliminación de tareas</h2>
    </div>
    <form [formGroup]="taskEliminationForm">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="full">
                        <h2>Gestor</h2>
                        <mat-form-field appearance="fill">
                            
                            <mat-select [(value)]="SelectedAdministrativeUser" formControlName="SelectedAdministrativeUser"
                                (selectionChange)="onAdminUserChange($event)">
                               
                                <mat-option *ngFor="let user of admintrativeUsers" [value]="user.administrativa">
                                    {{user.nombre}}
                                </mat-option>
                                
                            </mat-select>



                        </mat-form-field>                     
                    </div>
                </div>
                <div class="block-looper">
                    <h2>Enviar a</h2>
                    <fieldset id="Enviar">
                        <legend></legend>
                        <div class="three-view">
                            <label class="container-radio" for="all">Todos los médicos
                                <input type="radio" id="all" value="all" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="half">
                            <label class="container-radio" for="single">El medico
                                <input type="radio" id="single" value="single" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>

                        <div class="full" *ngIf="hideElMedicoInput">
                            <mat-form-field appearance="fill">
                                <mat-select [(value)]="SelectedDoctor" panelClass="cus-search-select"  formControlName="SelectedDoctor"
                                    (selectionChange)="onDoctorChange($event)">

                                    <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                    (input)="SearchDoctors()" />
                                    <div class="search-options">
                                        <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.medicoId">
                                            {{doctor.nombre}}
                                        </mat-option>
                                    </div>
                                    
                                </mat-select>
                            </mat-form-field>
                            <mat-error
                                *ngIf="taskEliminationForm.get('SelectedDoctor').invalid && taskEliminationForm.get('SelectedDoctor').touched">
                                <span *ngIf="taskEliminationForm.get('SelectedDoctor').hasError('required')"> Se debe
                                    indicar el medico</span>
                            </mat-error>
                        </div>
                    </fieldset>
                </div>
                <div class="block-looper">
                    <h2>Tareas</h2>
                    <fieldset id="Tareas">
                        <legend></legend>
                        <div class="three-view">
                            <label class="container-radio" for="PendientesDeNotificarEliminacion">Pendientes de
                                notificar eliminación
                                <input type="radio" id="PendientesDeNotificarEliminacion"
                                    value="PendientesDeNotificarEliminacion" (click)="tareasChangeHandler($event)"
                                    name="Tareas" formControlName="Tareas">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="full">
                            <label class="container-radio" for="Notificadas">Notificadas
                                <input type="radio" id="Notificadas" value="Notificadas"
                                    (click)="tareasChangeHandler($event)" name="Tareas" formControlName="Tareas">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </fieldset>
                    <div class="task-elimination-date" *ngIf="hideNotificadasDateField">
                        <app-date-period-selector [IsBothDatesRequired]="true" [DateType]="DateFilterType.Common"
                            [PeriodFrom]="getFormControl('DateFrom')" [PeriodTo]="getFormControl('DateTo')"
                            (FromDateChanged)="setFilterValues('commonDateFrom', $event)"
                            (ToDateChanged)="setFilterValues('commonDateTo', $event)"
                            required-error-message="Se debe indicar el period de tareas enviadas">
                        </app-date-period-selector>
                    </div>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onSubmit()"><span
                    class="mat-button-wrapper mat-button-wrapper-text-center">Aceptar
                    <mat-icon *ngIf="IsCancelDissabled"><mat-spinner color="white" diameter="20">
                    </mat-spinner></mat-icon>
                </span></button>
            <button [disabled]="IsCancelDissabled" mat-button color="accent" class="cancel" (click)="close()"><span
                    class="mat-button-wrapper mat-button-wrapper-text-center">Cancelar</span></button>
        </div>
    </form>
</div>